var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardClaimProcedure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard-claim-procedure",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.94,
    height: 82.58,
    viewBox: "0 0 123.94 82.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198983",
    "data-name": "Rectangle 198983",
    width: 123.94,
    height: 82.58,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232612",
    "data-name": "Group 232612",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419001",
    "data-name": "Path 419001",
    d: "M19.442,224.728.01,167.707,0,152.366l39.054-.012s3.3,2.644,3.2,8.642-3.2,7.321-3.2,7.321l21.969,40.806Z",
    transform: "translate(0 -145.479)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419002",
    "data-name": "Path 419002",
    d: "M41.374,171.362h-30.9a.1.1,0,1,1,0-.2c2.678,0,4.857-3.376,4.857-7.526s-2.179-7.526-4.857-7.526a.1.1,0,1,1,0-.2c2.788,0,5.056,3.466,5.056,7.725,0,3.659-1.674,6.732-3.913,7.526H41.374a.1.1,0,1,1,0,.2",
    transform: "translate(-9.905 -148.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419003",
    "data-name": "Path 419003",
    d: "M15.98,507.986a.1.1,0,0,1-.053-.184c2.057-1.293,2.672-4.908,1.43-8.41a10.237,10.237,0,0,0-2.768-4.249A4.838,4.838,0,0,0,11,493.755a.1.1,0,0,1-.021-.2c2.524-.259,5.284,2.164,6.562,5.768a10.413,10.413,0,0,1,.529,5.18,4.977,4.977,0,0,1-2.041,3.465.1.1,0,0,1-.053.015",
    transform: "translate(-10.402 -471.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419004",
    "data-name": "Path 419004",
    d: "M124.131,823.426a.1.1,0,0,1-.053-.184c2.057-1.293,2.672-4.908,1.43-8.411a10.237,10.237,0,0,0-2.768-4.249,4.835,4.835,0,0,0-3.585-1.388.1.1,0,0,1-.109-.089.1.1,0,0,1,.089-.109c2.523-.26,5.284,2.164,6.562,5.768a10.413,10.413,0,0,1,.529,5.18,4.977,4.977,0,0,1-2.041,3.465.1.1,0,0,1-.053.015",
    transform: "translate(-113.673 -772.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419005",
    "data-name": "Path 419005",
    d: "M234.536,1138.872a.1.1,0,0,1-.053-.184c2.057-1.293,2.672-4.908,1.43-8.411a10.239,10.239,0,0,0-2.768-4.249,4.837,4.837,0,0,0-3.585-1.388.1.1,0,0,1-.109-.089.1.1,0,0,1,.089-.109c2.524-.259,5.284,2.164,6.562,5.768a10.413,10.413,0,0,1,.529,5.18,4.977,4.977,0,0,1-2.041,3.465.1.1,0,0,1-.053.015",
    transform: "translate(-219.096 -1073.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419006",
    "data-name": "Path 419006",
    d: "M347.666,1452.862a.1.1,0,0,1-.092-.138,9.343,9.343,0,0,0-.13-6.448,10.237,10.237,0,0,0-2.768-4.249,4.84,4.84,0,0,0-3.585-1.388.1.1,0,0,1-.109-.089.1.1,0,0,1,.089-.109c2.524-.26,5.284,2.164,6.562,5.768a9.544,9.544,0,0,1,.126,6.59.1.1,0,0,1-.092.062",
    transform: "translate(-325.594 -1375.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419007",
    "data-name": "Path 419007",
    d: "M150.619,808.805h-24.5a.1.1,0,0,1,0-.2h24.5a.1.1,0,0,1,0,.2",
    transform: "translate(-120.329 -772.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419008",
    "data-name": "Path 419008",
    d: "M255.955,1124.248h-24.5a.1.1,0,1,1,0-.2h24.5a.1.1,0,1,1,0,.2",
    transform: "translate(-220.912 -1073.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419009",
    "data-name": "Path 419009",
    d: "M369.176,1440.252h-24.5a.1.1,0,1,1,0-.2h24.5a.1.1,0,1,1,0,.2",
    transform: "translate(-329.024 -1375.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419010",
    "data-name": "Path 419010",
    d: "M355.929,885.855,243.15,928.361H356.029Z",
    transform: "translate(-232.178 -845.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419011",
    "data-name": "Path 419011",
    d: "M241.043,926.354a.1.1,0,0,1-.035-.193l112.779-42.505a.1.1,0,1,1,.07.186L241.078,926.347a.1.1,0,0,1-.035.006",
    transform: "translate(-230.071 -843.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419012",
    "data-name": "Path 419012",
    d: "M494.61,1135.984l7.162,24.13,11.728-4.42Z",
    transform: "translate(-472.29 -1084.722)",
    fill: "#4256a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419013",
    "data-name": "Path 419013",
    d: "M475.917,564.552l-12.2,12.506L449.9,562.8a11.41,11.41,0,0,0-12-2.816l-20.593,7.293a11.409,11.409,0,0,0-5.121,17.856l15.489,20.243c3.013,3.818,8.68,7.009,13.523,6.558l18.654-2.182,22.168-23.034Z",
    transform: "translate(-391.212 -534.087)",
    fill: "#4256a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419014",
    "data-name": "Path 419014",
    d: "M1107.327,1281.192l-16.573,1.627Z",
    transform: "translate(-1041.533 -1223.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419015",
    "data-name": "Path 419015",
    d: "M1088.649,1280.814a.1.1,0,0,1-.01-.2l16.573-1.627a.1.1,0,1,1,.019.2l-16.573,1.627h-.01",
    transform: "translate(-1039.428 -1221.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419016",
    "data-name": "Path 419016",
    d: "M840.139,949.042l-15.251-17.081Z",
    transform: "translate(-787.664 -889.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419017",
    "data-name": "Path 419017",
    d: "M838.032,947.035a.1.1,0,0,1-.074-.033l-15.251-17.081a.1.1,0,0,1,.149-.133l15.251,17.081a.1.1,0,0,1-.074.166",
    transform: "translate(-785.558 -887.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419018",
    "data-name": "Path 419018",
    d: "M1537.882,952.239l-3.253,2.745Z",
    transform: "translate(-1465.378 -909.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419019",
    "data-name": "Path 419019",
    d: "M1532.522,952.975a.1.1,0,0,1-.064-.176l3.253-2.745a.1.1,0,0,1,.128.152l-3.253,2.745a.1.1,0,0,1-.064.023",
    transform: "translate(-1463.271 -907.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419020",
    "data-name": "Path 419020",
    d: "M1311.566,881.252l8.8,17.651Z",
    transform: "translate(-1252.381 -841.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419021",
    "data-name": "Path 419021",
    d: "M1318.26,896.895a.1.1,0,0,1-.089-.055l-8.8-17.651a.1.1,0,0,1,.178-.089l8.8,17.651a.1.1,0,0,1-.089.144",
    transform: "translate(-1250.274 -839.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419022",
    "data-name": "Path 419022",
    d: "M1752.906,652.161l-32.2,4.6s.282,16.336,1.878,25.254,7.805,18.731,14.847,19.482l29.469-4.153s-5.334-.781-8.731-7.861c-7.792-16.242-5.26-37.323-5.26-37.323",
    transform: "translate(-1643.056 -622.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419023",
    "data-name": "Path 419023",
    d: "M1735.322,699.491h-.011c-7.2-.768-13.357-10.753-14.934-19.564s-1.876-25.107-1.879-25.27a.1.1,0,0,1,.085-.1l32.2-4.6a.1.1,0,0,1,.113.11,84.615,84.615,0,0,0-.292,12.558c.311,6.651,1.525,16.336,5.542,24.71a15.145,15.145,0,0,0,5.592,6.538,9.1,9.1,0,0,0,3.064,1.268.1.1,0,0,1,0,.2l-29.469,4.153h-.014m-16.623-44.75c.026,1.307.358,16.678,1.875,25.151a32.393,32.393,0,0,0,5.364,12.763c2.825,3.931,6.157,6.287,9.383,6.636l28.923-4.076a10.344,10.344,0,0,1-2.6-1.167,15.335,15.335,0,0,1-5.677-6.628c-4.032-8.4-5.25-18.12-5.562-24.791a86.322,86.322,0,0,1,.278-12.459Z",
    transform: "translate(-1640.949 -620.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419024",
    "data-name": "Path 419024",
    d: "M1847.675,768.437l-22.318,3.188c-.083-2.146-.108-3.6-.108-3.6l22.465-3.209s-.073,1.38-.04,3.616",
    transform: "translate(-1742.884 -730.307)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419025",
    "data-name": "Path 419025",
    d: "M1831.976,993.155a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,0,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1749.212 -945.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419026",
    "data-name": "Path 419026",
    d: "M1839.713,1073.112a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,1,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1756.599 -1021.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419027",
    "data-name": "Path 419027",
    d: "M1848.74,1153.065a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,0,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1765.219 -1097.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419028",
    "data-name": "Path 419028",
    d: "M1870.664,1243.334a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,1,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1786.154 -1183.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419029",
    "data-name": "Path 419029",
    d: "M1887.562,1326.139a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,0,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1802.289 -1263.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419030",
    "data-name": "Path 419030",
    d: "M1912.91,1403.876a.1.1,0,0,1-.014-.2l22.318-3.188a.1.1,0,0,1,.028.2l-22.318,3.188h-.014",
    transform: "translate(-1826.494 -1337.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419031",
    "data-name": "Path 419031",
    d: "M1829.591,913.035a.1.1,0,0,1-.014-.2l22.465-3.209a.1.1,0,0,1,.028.2l-22.466,3.209h-.014",
    transform: "translate(-1746.934 -868.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419032",
    "data-name": "Path 419032",
    d: "M2036.847,1611.948h-.008c-1.866-.156-3.6-2.988-3.673-3.108a.1.1,0,0,1,.073-.15l11.186-1.312a.1.1,0,0,1,.1.061,6.425,6.425,0,0,0,2.474,2.773.1.1,0,0,1-.034.185l-10.106,1.551h-.015m-3.427-3.08c.368.563,1.884,2.742,3.424,2.88l9.829-1.508a6.477,6.477,0,0,1-2.3-2.656Z",
    transform: "translate(-1941.403 -1534.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419033",
    "data-name": "Path 419033",
    d: "M2362.783,1580.908c0,.99,1.724,1.792,3.851,1.792s3.851-.8,3.851-1.792-1.724-1.792-3.851-1.792-3.851.8-3.851,1.792",
    transform: "translate(-2256.161 -1507.857)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419034",
    "data-name": "Path 419034",
    d: "M1823.752,528.995a9.662,9.662,0,0,0-6.938-3.061c-4.081.051-6.938,3.061-7.4,4.591s-2.6,1.632-3.673,1.836-1.293,3.488,1.113,3.048l4.5-.667s-.106,4.106,1.788,4.047c2.113-.066,1.839-4.513,1.839-4.513l.864-.158s-.2,5.9,2.4,6.1a1.971,1.971,0,0,0,2.091-1.887,1.675,1.675,0,0,0,2.143-.561c.765-1.224.663-1.785.663-1.785s1.326,1.173,2.347-.612.357-5.356-.306-6.173a.992.992,0,0,0-1.428-.2",
    transform: "translate(-1723.524 -502.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419035",
    "data-name": "Path 419035",
    d: "M1816.334,538.217c-.067,0-.136,0-.208-.008-2.484-.195-2.508-5.2-2.493-6.08l-.657.121c.022.507.074,2.973-.9,4.039a1.427,1.427,0,0,1-1.041.492,1.233,1.233,0,0,1-.941-.38c-.9-.9-.952-3.108-.951-3.651l-4.38.65a1.521,1.521,0,0,1-1.958-1.268c-.155-.83.159-1.852.812-1.976.149-.028.318-.055.5-.083,1.148-.179,2.72-.424,3.1-1.684.494-1.646,3.419-4.611,7.491-4.662a9.794,9.794,0,0,1,6.961,3.026,1.074,1.074,0,0,1,1.483.276c.717.882,1.337,4.5.315,6.285a1.835,1.835,0,0,1-1.238,1.023,1.587,1.587,0,0,1-1.1-.265,4.009,4.009,0,0,1-.676,1.643,1.724,1.724,0,0,1-2.145.648,2.771,2.771,0,0,1-.317.91,1.81,1.81,0,0,1-1.657.945m-2.6-6.307a.1.1,0,0,1,.1.1c0,.058-.17,5.8,2.307,6a1.859,1.859,0,0,0,1.985-1.8.1.1,0,0,1,.142-.082,1.562,1.562,0,0,0,2.015-.524,2.993,2.993,0,0,0,.65-1.716.1.1,0,0,1,.164-.091,1.49,1.49,0,0,0,1.1.339,1.653,1.653,0,0,0,1.1-.926c1-1.754.321-5.3-.3-6.06a.886.886,0,0,0-1.289-.189.1.1,0,0,1-.154-.039,9.677,9.677,0,0,0-6.845-3,8.573,8.573,0,0,0-5,1.721,6.414,6.414,0,0,0-2.3,2.8c-.414,1.38-2.126,1.647-3.258,1.824-.178.028-.346.054-.492.082-.477.091-.8.955-.653,1.744a1.327,1.327,0,0,0,1.729,1.108l4.5-.667a.1.1,0,0,1,.081.024.1.1,0,0,1,.034.077c0,.027-.057,2.68.891,3.623a1.031,1.031,0,0,0,.794.322,1.236,1.236,0,0,0,.9-.427c1.007-1.1.844-3.953.842-3.981a.1.1,0,0,1,.081-.1l.864-.158.018,0",
    transform: "translate(-1721.416 -500.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419036",
    "data-name": "Path 419036",
    d: "M2197.216,619.748a.1.1,0,0,1-.1-.093c0-.046-.287-4.589-.387-6a.1.1,0,0,1,.2-.014c.1,1.408.384,5.952.387,6a.1.1,0,0,1-.093.106h-.006",
    transform: "translate(-2097.6 -585.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419037",
    "data-name": "Path 419037",
    d: "M2131.3,629.974a.1.1,0,0,1-.1-.093c0-.062-.4-6.227-.563-7.967a.1.1,0,0,1,.09-.109.1.1,0,0,1,.108.09c.168,1.744.56,7.912.564,7.974a.1.1,0,0,1-.093.106h-.006",
    transform: "translate(-2034.49 -593.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419038",
    "data-name": "Path 419038",
    d: "M2039.316,645.128a.1.1,0,0,1-.1-.092l-.208-2.843a.1.1,0,0,1,.2-.015l.208,2.843a.1.1,0,0,1-.092.107h-.007",
    transform: "translate(-1946.997 -613.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419039",
    "data-name": "Path 419039",
    d: "M1944.194,639.936a.1.1,0,0,1-.1-.1c-.078-3.4,1.118-3.74,1.169-3.753a.1.1,0,0,1,.049.193c-.018.005-1.093.352-1.019,3.555a.1.1,0,0,1-.1.1Z",
    transform: "translate(-1856.362 -607.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419040",
    "data-name": "Path 419040",
    d: "M2149.919,1649.9l.591.649Z",
    transform: "translate(-2052.902 -1575.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419041",
    "data-name": "Path 419041",
    d: "M2148.4,1648.547a.1.1,0,0,1-.074-.032l-.591-.649a.1.1,0,0,1,.147-.134l.591.649a.1.1,0,0,1-.074.167",
    transform: "translate(-2050.795 -1573.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419042",
    "data-name": "Path 419042",
    d: "M2082.629,1573.026l1.74,3.469-3.1-2.139Z",
    transform: "translate(-1987.353 -1502.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419043",
    "data-name": "Path 419043",
    d: "M2082.262,1574.49a.1.1,0,0,1-.057-.018l-3.1-2.139a.1.1,0,0,1-.013-.153l1.357-1.33a.1.1,0,0,1,.086-.027.1.1,0,0,1,.073.054l1.74,3.469a.1.1,0,0,1-.024.12.1.1,0,0,1-.065.024m-2.942-2.252,2.678,1.85-1.5-3Z",
    transform: "translate(-1985.246 -1499.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419044",
    "data-name": "Path 419044",
    d: "M1602.19,1020.54c.241.321,20.627,24.647,20.627,24.647s.214.506-.374,1.2a1.207,1.207,0,0,1-1.24.481s-21.114-23.474-21.518-23.909c-.723-.777,1.91-3.212,2.505-2.418",
    transform: "translate(-1527.379 -974.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419045",
    "data-name": "Path 419045",
    d: "M1611.308,1032.837c.417-.379.665-.785.554-.907s-.539.086-.956.466-.665.786-.554.907.539-.086.956-.466",
    transform: "translate(-1537.659 -985.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419046",
    "data-name": "Path 419046",
    d: "M1658.1,1022.414a1,1,0,0,1-.722-.433,11.223,11.223,0,0,1-.924-1.993c-.5-1.23-1.186-2.915-1.579-3.033-.639-.192-1.047.556-1.064.588a.1.1,0,0,1-.078.052.1.1,0,0,1-.087-.036l-.806-.972a.1.1,0,0,1,.153-.127l.716.864a1.136,1.136,0,0,1,1.222-.561c.45.135.992,1.39,1.707,3.149a11.689,11.689,0,0,0,.893,1.941c.226.273.456.4.648.351a.549.549,0,0,0,.35-.461.1.1,0,1,1,.194.043.735.735,0,0,1-.5.612.537.537,0,0,1-.127.015",
    transform: "translate(-1578.232 -970.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419047",
    "data-name": "Path 419047",
    d: "M1439.272,1262.029l-5.237.763a17.177,17.177,0,0,0-1.525,8.948c.762,7.219,3.864,8.947,3.864,8.947l5.33-.736Z",
    transform: "translate(-1367.783 -1205.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419048",
    "data-name": "Path 419048",
    d: "M1434.288,1278.684a.1.1,0,0,1-.048-.013c-.128-.072-3.155-1.837-3.914-9.024a17.44,17.44,0,0,1,1.536-9,.1.1,0,0,1,.074-.052l5.237-.763a.1.1,0,0,1,.074.019.1.1,0,0,1,.039.066l2.432,17.922a.1.1,0,0,1-.085.112l-5.33.736h-.014m-2.273-17.9a17.289,17.289,0,0,0-1.492,8.846c.71,6.727,3.481,8.661,3.786,8.854l5.2-.718-2.4-17.724Z",
    transform: "translate(-1365.698 -1202.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419049",
    "data-name": "Path 419049",
    d: "M1546.89,1158.558s5.583-.99,7.565-2.882,3.422-2.612,4.5-1.441-.18,3.873-1.531,5.223-.09,1.891.811,2.342,6.394,1.351,9.366,1.531,2.161,2.882-.36,3.422a3.041,3.041,0,0,1-2.432,3.062s-.18,1.981-2.972,2.522c0,0,1.171,1.441-2.882,2.612a54.774,54.774,0,0,1-9.636,1.531s-2.341-1.891-3.782-7.385a15.759,15.759,0,0,1,1.351-10.537",
    transform: "translate(-1475.401 -1101.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419050",
    "data-name": "Path 419050",
    d: "M1547.3,1174.476a.1.1,0,0,1-.063-.022c-.1-.078-2.383-1.975-3.816-7.437a15.988,15.988,0,0,1,1.36-10.61.1.1,0,0,1,.07-.05c.056-.01,5.577-1.007,7.514-2.856,1.5-1.434,2.561-2.06,3.43-2.035a1.678,1.678,0,0,1,1.215.6c1.121,1.215-.159,3.987-1.534,5.361-.418.418-.6.784-.555,1.088.077.467.688.771,1.229,1.038l.111.055c.894.447,6.386,1.342,9.328,1.521,1.19.072,1.935.574,1.993,1.343.063.844-.763,1.907-2.258,2.258a3.154,3.154,0,0,1-2.444,3.061,3.352,3.352,0,0,1-2.9,2.512.975.975,0,0,1,.051.732c-.233.745-1.264,1.386-3.063,1.906a55.291,55.291,0,0,1-9.657,1.535h-.006m-2.366-17.932a15.746,15.746,0,0,0-1.32,10.422c1.328,5.065,3.449,7.068,3.72,7.308a54.653,54.653,0,0,0,9.575-1.525c2.156-.623,2.782-1.308,2.928-1.774a.764.764,0,0,0-.1-.679.1.1,0,0,1,.058-.16c2.68-.519,2.884-2.355,2.892-2.433a.1.1,0,0,1,.073-.087,2.92,2.92,0,0,0,2.359-2.959.1.1,0,0,1,.078-.1c1.44-.308,2.24-1.293,2.182-2.066-.051-.67-.709-1.093-1.807-1.159-2.958-.179-8.5-1.087-9.4-1.541l-.11-.055c-.583-.289-1.243-.617-1.336-1.185a1.534,1.534,0,0,1,.61-1.261c1.319-1.319,2.57-3.956,1.528-5.085a1.488,1.488,0,0,0-1.075-.534c-.813-.03-1.825.585-3.286,1.98-1.905,1.819-6.983,2.792-7.569,2.9",
    transform: "translate(-1473.378 -1099.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419051",
    "data-name": "Path 419051",
    d: "M1812.333,1435.881a52.844,52.844,0,0,1-6.816-.479.1.1,0,0,1-.086-.111.1.1,0,0,1,.112-.086,38.82,38.82,0,0,0,10.242.282.1.1,0,1,1,.033.2,23.668,23.668,0,0,1-3.485.2",
    transform: "translate(-1723.959 -1370.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419052",
    "data-name": "Path 419052",
    d: "M1773.1,1510.245c-.683,0-1.392-.02-2.12-.068a.1.1,0,0,1-.093-.106.1.1,0,0,1,.106-.093,34.719,34.719,0,0,0,9.368-.687.1.1,0,1,1,.047.193,34.46,34.46,0,0,1-7.309.76",
    transform: "translate(-1690.97 -1441.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419053",
    "data-name": "Path 419053",
    d: "M1749.2,1566.284a.1.1,0,0,1,0-.2,70.325,70.325,0,0,0,7.4-.912.1.1,0,0,1,.034.2,70.51,70.51,0,0,1-7.424.915Z",
    transform: "translate(-1670.173 -1494.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419054",
    "data-name": "Path 419054",
    d: "M1934.258,1444.255a9.321,9.321,0,0,0,1.813-.14l4.761,5.683s.214.506-.374,1.2a1.207,1.207,0,0,1-1.24.481l-6.614-7.353a12.826,12.826,0,0,0,1.654.13",
    transform: "translate(-1845.394 -1378.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419055",
    "data-name": "Path 419055",
    d: "M546.74,1231.8l-13.116-17.454Z",
    transform: "translate(-509.544 -1159.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419056",
    "data-name": "Path 419056",
    d: "M544.633,1229.792a.1.1,0,0,1-.08-.04L531.438,1212.3a.1.1,0,1,1,.159-.12l13.116,17.454a.1.1,0,0,1-.08.159",
    transform: "translate(-507.437 -1157.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419057",
    "data-name": "Path 419057",
    d: "M659.1,89.675a13.6,13.6,0,0,0,.26,1.474,14.951,14.951,0,0,0,.429,1.587,7.6,7.6,0,0,0,1.416,2.537A6.854,6.854,0,0,0,666,97.658a7.548,7.548,0,0,0,5.324-1.821,6.9,6.9,0,0,0,2.319-4.254,3.877,3.877,0,0,0,.907-.8,7.472,7.472,0,0,0,1.318-2.566,8.635,8.635,0,0,0,.409-3.268,5.426,5.426,0,0,0-2.8-4.6,3.437,3.437,0,0,0-2.556-.157c-.817.287-1.619,1.091-2.516.715-.233-.1-.454-.234-.684-.341a6.009,6.009,0,0,0-.718-.281,3.052,3.052,0,0,0-1.351-.172,1.573,1.573,0,0,0-1.051.639,6.484,6.484,0,0,0-.565,1.041,2.135,2.135,0,0,1-.642.876,2.512,2.512,0,0,1-1.241.279,2.38,2.38,0,0,0-1.213.368,2.288,2.288,0,0,0-.785,1,2.649,2.649,0,0,0-.159,1.365,2.777,2.777,0,0,1,.041.79,1.226,1.226,0,0,1-.325.575,3.45,3.45,0,0,0-.6,2.628",
    transform: "translate(-629.328 -76.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419058",
    "data-name": "Path 419058",
    d: "M669.27,414.628a4.8,4.8,0,0,0,.963-2.113l1.642-8.853,7.227-.009.07,8.995,2.248-.493,13.75,27.1-27.986-22Z",
    transform: "translate(-637.077 -385.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419059",
    "data-name": "Path 419059",
    d: "M665.076,415.243a.1.1,0,0,1-.078-.162l2.086-2.622a4.716,4.716,0,0,0,.943-2.069l1.642-8.853a.1.1,0,0,1,.1-.081l7.227-.009h0a.1.1,0,0,1,.1.1l.069,8.872,2.128-.466a.1.1,0,0,1,.043.194l-2.248.493a.1.1,0,0,1-.121-.1l-.069-8.9-7.045.009-1.627,8.772a4.917,4.917,0,0,1-.983,2.157l-2.086,2.622a.1.1,0,0,1-.078.038",
    transform: "translate(-634.969 -383.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419060",
    "data-name": "Path 419060",
    d: "M729.016,602.865a19.964,19.964,0,0,1-4.891-.772.1.1,0,0,1,.057-.191c.04.012,4.009,1.175,6.417.6,2.367-.561,2.779-1.654,2.783-1.665a.1.1,0,0,1,.188.065c-.017.049-.438,1.2-2.925,1.793a7.16,7.16,0,0,1-1.628.165",
    transform: "translate(-691.381 -573.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419061",
    "data-name": "Path 419061",
    d: "M888.035,649.546l-.412,2.835,1.919,1.046,4.28,11.31,11.893,9.358-3.929-7.709-11.105-13.422.275-1.7Z",
    transform: "translate(-847.568 -620.235)",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419062",
    "data-name": "Path 419062",
    d: "M693.279,630.12l-.018,0-8.788-1.616a.1.1,0,0,1,.036-.2l8.687,1.6.7-4.529a.1.1,0,0,1,.149-.071l3.7,2.162.621-3.167a.1.1,0,1,1,.2.038l-.648,3.3a.1.1,0,0,1-.148.067l-3.695-2.159-.693,4.485a.1.1,0,0,1-.1.084",
    transform: "translate(-653.508 -596.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419063",
    "data-name": "Path 419063",
    d: "M697.626,239.644a1.8,1.8,0,0,0-1.462,1.4,2.438,2.438,0,0,0,.532,2.018,3.819,3.819,0,0,0,1.783,1.166,2.1,2.1,0,0,1,.987.5c.339.4.259.982.318,1.5a3.39,3.39,0,0,0,2.1,2.558,8.037,8.037,0,0,0,3.4.505,8.306,8.306,0,0,0,2.2-.267,3.5,3.5,0,0,0,1.831-1.185c.8-1.06.709-2.519.583-3.84l-.807-8.463a10.908,10.908,0,0,1-6.657.732c-.419-.087-.929-.172-1.212.149a1.169,1.169,0,0,0-.185.817q.029,1.2.057,2.4a2.3,2.3,0,0,1-.184,1.187.862.862,0,0,1-.755.455c-.38-.04-.446-.4-.657-.675a2.129,2.129,0,0,0-1.862-.957",
    transform: "translate(-664.703 -224.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419064",
    "data-name": "Path 419064",
    d: "M702.8,247.285a7.63,7.63,0,0,1-3.07-.517,3.453,3.453,0,0,1-2.155-2.638c-.015-.132-.021-.269-.027-.4a1.661,1.661,0,0,0-.267-1.044,1.706,1.706,0,0,0-.8-.422l-.138-.045a3.913,3.913,0,0,1-1.829-1.2,2.526,2.526,0,0,1-.552-2.1,1.91,1.91,0,0,1,1.547-1.478,2.27,2.27,0,0,1,1.953,1,2.172,2.172,0,0,1,.161.254c.115.2.205.36.428.383a.765.765,0,0,0,.657-.405,2.219,2.219,0,0,0,.171-1.137l-.057-2.4a1.248,1.248,0,0,1,.21-.885c.337-.383.944-.257,1.307-.181a10.8,10.8,0,0,0,6.6-.725.1.1,0,0,1,.14.081l.807,8.463c.133,1.4.2,2.849-.6,3.909a3.615,3.615,0,0,1-1.883,1.221,8.4,8.4,0,0,1-2.223.271c-.121,0-.245,0-.37,0m-7.271-9.648a1.706,1.706,0,0,0-1.377,1.324,2.325,2.325,0,0,0,.512,1.934,3.715,3.715,0,0,0,1.737,1.134l.136.044a1.851,1.851,0,0,1,.9.482,1.829,1.829,0,0,1,.315,1.164c.006.129.012.263.026.388a3.3,3.3,0,0,0,2.037,2.478,8.018,8.018,0,0,0,3.356.5,8.227,8.227,0,0,0,2.171-.263,3.42,3.42,0,0,0,1.78-1.149c.756-1,.7-2.357.563-3.77l-.794-8.325a11.005,11.005,0,0,1-6.592.682c-.433-.09-.877-.155-1.117.118a1.079,1.079,0,0,0-.161.749l.057,2.4a2.4,2.4,0,0,1-.2,1.238.961.961,0,0,1-.852.506c-.324-.034-.454-.262-.58-.483a2.013,2.013,0,0,0-.146-.231,2.082,2.082,0,0,0-1.771-.919",
    transform: "translate(-662.596 -222.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419065",
    "data-name": "Path 419065",
    d: "M735.544,381.914a.1.1,0,0,1-.073-.032,2.729,2.729,0,0,0-1.613-.843.1.1,0,0,1,.027-.2,2.932,2.932,0,0,1,1.732.905.1.1,0,0,1-.006.141.1.1,0,0,1-.067.026",
    transform: "translate(-700.659 -363.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419066",
    "data-name": "Path 419066",
    d: "M1150.331,25.331h31.447a3.942,3.942,0,0,0,3.942-3.942V6.148a3.942,3.942,0,0,0-3.942-3.942h-19.621a3.942,3.942,0,0,0-3.942,3.942v12.7Z",
    transform: "translate(-1098.422 -2.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419067",
    "data-name": "Path 419067",
    d: "M1179.671,23.324h-31.447a.1.1,0,0,1-.063-.176l7.847-6.452V4.041A4.046,4.046,0,0,1,1160.05,0h19.621a4.046,4.046,0,0,1,4.041,4.041V19.283a4.046,4.046,0,0,1-4.041,4.041m-31.169-.2h31.169a3.847,3.847,0,0,0,3.842-3.842V4.041A3.847,3.847,0,0,0,1179.671.2H1160.05a3.847,3.847,0,0,0-3.842,3.842v12.7a.1.1,0,0,1-.036.077Z",
    transform: "translate(-1096.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419068",
    "data-name": "Path 419068",
    d: "M1505.906,97.252l3.708,2.051a1.726,1.726,0,0,0,1.632.021l4-2.082a1.727,1.727,0,0,0,.93-1.532V85.48a1.726,1.726,0,0,0-1.726-1.726h-7.711a1.726,1.726,0,0,0-1.726,1.726V95.742a1.727,1.727,0,0,0,.891,1.511",
    transform: "translate(-1437.1 -79.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419069",
    "data-name": "Path 419069",
    d: "M1508.343,97.514a1.825,1.825,0,0,1-.884-.229l-3.708-2.051a1.826,1.826,0,0,1-.942-1.6V83.375a1.828,1.828,0,0,1,1.826-1.826h7.711a1.828,1.828,0,0,1,1.826,1.826V93.606a1.82,1.82,0,0,1-.983,1.62l-4,2.082a1.825,1.825,0,0,1-.843.206m-3.708-15.766a1.629,1.629,0,0,0-1.627,1.627V93.636a1.627,1.627,0,0,0,.839,1.424l3.708,2.051a1.624,1.624,0,0,0,1.538.02l4-2.082a1.622,1.622,0,0,0,.876-1.443V83.375a1.629,1.629,0,0,0-1.627-1.627Z",
    transform: "translate(-1434.994 -77.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419070",
    "data-name": "Path 419070",
    d: "M1542.05,129.626a.231.231,0,0,0,.108-.026l4-2.082a.232.232,0,0,0,.126-.207V117.08a.233.233,0,0,0-.233-.233h-7.711a.233.233,0,0,0-.233.233v10.261a.233.233,0,0,0,.12.2l3.708,2.051a.234.234,0,0,0,.113.029",
    transform: "translate(-1468.701 -111.574)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419071",
    "data-name": "Path 419071",
    d: "M1577.3,170.845a.1.1,0,0,1-.078-.038l-1.928-2.47a.1.1,0,0,1,.157-.122l1.83,2.345,2.822-5.761a.1.1,0,0,1,.179.088l-2.892,5.9a.1.1,0,0,1-.079.055h-.01",
    transform: "translate(-1504.183 -157.307)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardClaimProcedure);
export default __webpack_public_path__ + "static/media/dashboard-claim-procedure.adc929c5f2673e1d5eb2a064769a206c.svg";
export { ForwardRef as ReactComponent };